// extracted by mini-css-extract-plugin
export default {"grid":"equipe_grid__i+xmE","titre_couleur":"equipe_titre_couleur__q5NQ9"};